import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {WaTemplate, WaTemplateService} from "./wa-template.service";
import {Observable, of} from "rxjs";
import {tap} from "rxjs/operators";
import {TemplateContentButtonType} from "../../../../shared/utils/pipes/TemplateContentButtonPipe";

@Component({
    selector: 'wa-template-preview',
    templateUrl: './wa-template-preview.component.html',
    styleUrls: ['./wa-template-preview.component.scss']
})
export class WaTemplatePreviewComponent implements OnInit, OnChanges {

    @Input() waTemplateId: string;
    @Input() templateData: WaTemplate;


    @Input()
    waTemplateBody: Object
    @Input() headerValue: string | undefined = undefined;

    waTemplate: Observable<WaTemplate> = undefined;

    bodyText: string;
    bodyTextTransform: string;

    headerText: string;
    headerTextTransform: string;

    constructor(private waTemplateService: WaTemplateService) {
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.waTemplateId || changes.templateData) {
            if (this.waTemplateId && !this.templateData) {
                this.waTemplate = this.waTemplateService.get_template(this.waTemplateId).pipe(
                    tap((template: WaTemplate) => {
                        this.transformBodyText(template);
                        // this.transformHeaderText(template);
                    })
                )
            } else {
                this.waTemplate = of(this.templateData)
                this.transformBodyText(this.templateData)
                // this.transformHeaderText(this.templateData);
            }

            if (changes.waTemplateBody) {
                this.bodyTextTransform = transform(this.bodyText, this.waTemplateBody)
            }

            if (changes.headerValue) {
                this.headerTextTransform = transform(this.headerText, {1: this.headerValue})
            }
        }

    }

    private transformBodyText(template: WaTemplate) {
        if (template) {
            this.bodyText = template?.templateContent?.body?.text
            if (this.bodyText === undefined) {
                return
            }
            this.bodyTextTransform = transform(this.bodyText, this.waTemplateBody)
        }
    }

    private transformHeaderText(template: WaTemplate) {
        if (template && template.templateContent.header && template.templateContent.header.type === 'text') {
            this.headerText = template?.templateContent?.header?.text?.text;
            if (this.headerText !== undefined && this.headerText.includes('{{1}}')) {
                this.headerTextTransform = transform(this.headerText, {1: this.headerValue});
            }
        }
    }

    protected readonly TemplateContentButtonType = TemplateContentButtonType;
}


const transform = (value: string, waTemplateBody: Object): string => {
    if (value) {
        for (let waTemplateBodyKey in waTemplateBody) {
            if (waTemplateBody[waTemplateBodyKey].length > 0) {
                value = value.replace(`{{${waTemplateBodyKey}}}`, waTemplateBody[waTemplateBodyKey]);
            }
        }
        return value;
    }

    return "";
}